import { appStore } from "@app/store/store"
import { ORDER_LINE_TYPES } from "./constants"

export const groupBy = function (xs, key) {
	return xs.reduce(function (rv, x) {
		;(rv[x[key]] = rv[x[key]] || []).push(x)
		return rv
	}, {})
}

export const compareDate = (d1, d2) => {
	let dt1 = new Date(d1)
	let dt2 = new Date(d2)

	dt1.setMilliseconds(0)
	dt1.setSeconds(0)
	dt1.setHours(0)
	dt1.setMinutes(0)
	dt2.setMilliseconds(0)
	dt2.setSeconds(0)
	dt2.setHours(0)
	dt2.setMinutes(0)

	return dt1.getTime() < dt2.getTime() ? -1 : dt1.getTime() == dt2.getTime() ? 0 : 1
}

export const emptyArray = length => Array.apply(null, Array(length))

export const flatFormattedOrderForKisok = (formattedOrder, paymentLine) => {
	let od = []
	let priceActions = appStore.get("order.priceActions")

	formattedOrder.orderLines.forEach(e => {
		let fd = { ...e.details[0] }
		fd.price = fd.unitPrice
		fd.unitPrice = fd.grossAmount / (fd.quantity || e.quantity)
		if (e.details.length > 1) {
			let details = e.details.slice(1)
			od.details = details
		}

		if (fd.typeId === ORDER_LINE_TYPES.Ticket) {
			fd.ticket = fd.description
		} else if (fd.typeId === ORDER_LINE_TYPES.VoucherDetail) {
			let priceAction = priceActions.find(
				a => (fd.voucherDetailToken && a.details[0].voucherDetailToken === fd.voucherDetailToken) || a.scanCode === fd.scanCode,
			)
			fd = {
				...fd,
				...priceAction,
				...priceAction.details[0],
				payment: priceAction.details[0].voucherDetail,
				amount: fd.grossAmount,
				voucherDetailToken: fd.voucherDetailToken,
				scanCode: fd.scanCode,
			}

			if (fd.paymentId) {
				fd.grossAmount = Math.abs(fd.grossAmount)
			}
		} else if (fd.typeId === ORDER_LINE_TYPES.Voucher) {
			fd.quantity = e.quantity
		}

		od.push(fd)
	})
	if (paymentLine) {
		od.push(paymentLine)
	}
	return {
		...formattedOrder,
		orderLines: od,
	}
}
